import { render } from "./dropdown.vue?vue&type=template&id=034b16c4"
import script from "./dropdown.vue?vue&type=script&lang=ts"
export * from "./dropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script